import React, {useContext} from 'react';
import BaseComponent, {AjaxParam} from '../common/BaseComponent/BaseComponent';
import {notify} from "../common/primitives/Notification/Notification";
import {_hasProperty} from "../common/helpers/HelperFunc";

const ContextCart = React.createContext({});


/**
 * @class ContextCartProvider
 * @property {array} contextData
 * @property {Function} isServiceInCart Дали дадената услуга е в количката.
 * @property {Function} isNewServiceInCart Дали дадената услуга е в количката. Проверява само между новите услуги
 * @property {Function} isServiceTypeInCart Дали даден тип услуга е в количката.
 * @property {Function} getNewDomainInCart Връща данните за даден домейн в количката. Глеад само новите услуги.
 * @property {Function} getNewServiceData Връща данните за дадена услуга в количката. Глеад само новите услуги.
 * @property {Function} getSelectedPriceForLineId Връща избраният service price id за даден ред.
 * @property {Function} removeFromCart Премахва услуга от количката
 * @property {Function} addDomainToCart Добавя домейн в количката
 * @property {Function} addServiceToCart Добавя услуга в количката по дадено servicePriceId
 * @property {Function} setContextData Задава данни в контекста.
 *
 */
class ContextCartProvider extends BaseComponent {

	constructor(props) {

		super(props);

		this.componentName = SHVO.pageState.componentData.contextCart.componentName;
		this.componentToken = SHVO.pageState.componentData.contextCart.componentToken;

		this.state = {
			contextData: SHVO.pageState.componentData.contextCart.componentData,
			isServiceInCart: this.isServiceInCart,
			isServiceTypeInCart: this.isServiceTypeInCart,
			isNewServiceInCart: this.isNewServiceInCart,
			getNewDomainInCart: this.getNewDomainInCart,
			getNewServiceData: this.getNewServiceData,
			getSelectedPriceForLineId: this.getSelectedPriceForLineId,
			removeFromCart: this.removeFromCart,
			addDomainToCart: this.addDomainToCart,
			addServiceToCart: this.addServiceToCart,
			addServiceToCartWithCount: this.addServiceToCartWithCount,
			setContextData: this.setContextData,
		}
	}

	/**
	 * Задава данни в контекста
	 *
	 * @param contextData
	 */
	setContextData = (contextData) => {
		const state = this.state;
		state.contextData = contextData;
		this.setState(state);
	};

	/**
	 * Дали дадената услуга е в количката.
	 * @param {string} serviceId
	 * @returns {boolean}
	 */
	isServiceInCart = (serviceId) => {
		let sIds = this.state.contextData.serviceIds;
		return sIds[serviceId] === serviceId;
	};

	/**
	 * Дали даден тип услуга е в количката.
	 * @param {string} serviceType
	 * @param {int} termMonths
	 * @returns {boolean}
	 */
	isServiceTypeInCart = (serviceType, termMonths = 0) => {
		let lines = this.state.contextData.lines;
		let hasService = false;

		lines.map((val, key) => {
			if (val.serviceType === serviceType) {
				if (termMonths > 0) {
					hasService = (val.termMonths === termMonths)
				} else {
					hasService = true;
				}
			}
		});

		return hasService;
	};

	/**
	 * Дали дадената услуга е в количката. Проверява само между новите услуги
	 * @param {string} serviceId
	 * @returns {boolean}
	 */
	isNewServiceInCart = (serviceId) => {
		if (_hasProperty(this.state.contextData, 'onlyNewServices')) {
			let sIds = this.state.contextData.onlyNewServices;
			return sIds[serviceId] === serviceId;
		} else {
			return false;
		}

	};
	/**
	 * Връща данните за даден домейн в количката. Глеад само новите услуги.
	 * @param {string} domainName
	 * @returns {[]}
	 */
	getNewDomainInCart = (domainName) => {
		let domainLineData = [];
		const lines = this.state.contextData.lines;
		if (lines.length > 0) {
			domainLineData = lines.filter(line => line.serviceName === domainName && line.isNewService === true && line.serviceType === 'Domains');
		}
		return domainLineData;
	};
	/**
	 * Връща данните за дадена услуга в количката. Глеад само новите услуги.
	 * @param {string} serviceId
	 * @returns {[]}
	 */
	getNewServiceData = (serviceId) => {
		let serviceData = [];
		const lines = this.state.contextData.lines;
		if (lines.length > 0) {
			serviceData = lines.filter(line => line.serviceId === serviceId && line.isNewService === true);
		}
		return serviceData;
	};

	/**
	 * Връща избраният service price id за даден ред.
	 * @param {string} lineId
	 * @returns {string}
	 */
	getSelectedPriceForLineId = (lineId) => {
		return this.state.contextData.lineServicePriceMap[lineId];
	};
	/**
	 * Премахва услуга от количката
	 * @param {string} lineId
	 * @param {Function} [callBackSuccess]
	 */
	removeFromCart = (lineId, callBackSuccess) => {
		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = (data) => {
			if (this.context.get('ComponentCart')) {
				this.context.set('ComponentCart', data);
				this.context.forceUpdate('ComponentCart');
			}


			const state = this.state;
			state.contextData = data.componentData;

			this.eventRaise('ToggleCartDisabledState', {disable: false});
			notify.success(this.messages['SERVICE_REMOVE_FROM_CART_SUCCESS']);

			this.setState(state, () => {
				if (typeof callBackSuccess === 'function') {
					callBackSuccess(data);
				}
			});
			if (data.componentData.countServices === 0) {
				this.eventRaise('ToggleCart', {isOpen: false});
			}
		};
		ajaxParam.callbackError = ({componentErrors}) => {
			this.eventRaise('ToggleCartDisabledState', {disable: false});
			const errorMessage = componentErrors[0];
			notify.error(this.messages[errorMessage] || errorMessage);
		}

		ajaxParam.cypressParamString = '?ContextCart-ActionRemoveFromCart';
		this.ajaxCall('ActionRemoveFromCart', {lineId: lineId}, ajaxParam);
	};
	/**
	 * Добавя домейн в количката
	 * @param {string} domainName
	 * @param {string} servicePriceId
	 * @param {Function} [callBackSuccess]
	 */
	addDomainToCart = (domainName, servicePriceId, callBackSuccess) => {
		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = (data) => {
			if (this.context.get('ComponentCart')) {
				this.context.set('ComponentCart', data);
				this.context.forceUpdate('ComponentCart');
			}


			const state = this.state;
			state.contextData = data.componentData;

			this.eventRaise('ToggleCartDisabledState', {disable: false});
			notify.success(this.messages['SERVICE_ADD_TO_CART_SUCCESS']);

			this.setState(state, () => {
				if (typeof callBackSuccess === 'function') {
					callBackSuccess(data);
				}
			});
		};
		ajaxParam.callbackError = ({componentErrors}) => {
			this.eventRaise('ToggleCartDisabledState', {disable: false});
			const errorMessage = componentErrors[0];
			notify.error(this.messages[errorMessage] || errorMessage);
		}

		const actionData = {
			domainName: domainName,
			servicePriceId: servicePriceId
		};
		ajaxParam.cypressParamString = '?ContextCart-ActionAddDomainToCart';
		this.ajaxCall('ActionAddDomainToCart', actionData, ajaxParam);
	};

	/**
	 * Добавя услуга в количката по дадено ServicePriceId
	 * @param {string} servicePriceId
	 * @param {string} breadCrumbMode
	 * @param {Function} [callBackSuccess]
	 */
	addServiceToCart = (servicePriceId, breadCrumbMode, callBackSuccess) => {
		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = (data) => {
			if (this.context.get('ComponentCartBig')) {
				this.context.set('ComponentCartBig', data);
				this.context.forceUpdate('ComponentCartBig');
			} else if (this.context.get('ComponentCart')) {
				this.context.set('ComponentCart', data);
				this.context.forceUpdate('ComponentCart');
			}


			const state = this.state;
			state.contextData = data.componentData;

			notify.success(this.messages['SERVICE_ADD_TO_CART_SUCCESS']);
			if (this.mounted) {
				this.setState(state, () => {
					if (typeof callBackSuccess === 'function') {
						callBackSuccess(data);
					}
				});
			} else {
				if (typeof callBackSuccess === 'function') {
					callBackSuccess(data);
				}
			}
		};
		const actionData = {
			servicePriceId: servicePriceId,
			breadCrumbMode: breadCrumbMode
		};
		ajaxParam.cypressParamString = '?ContextCart-ActionAddDServiceToCart';
		this.ajaxCall('ActionAddServiceToCart', actionData, ajaxParam);
	}

	/**
	 * Добавя услуга в количката по дадено ServicePriceId
	 * @param {string} servicePriceId
	 * @param {number} count
	 * @param {string?} breadCrumbMode
	 * @param {Function?} [callBackSuccess]
	 */
	addServiceToCartWithCount = (servicePriceId, count, breadCrumbMode, callBackSuccess) => {
		const ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = (data) => {
			if (this.context.get('ComponentCartBig')) {
				this.context.set('ComponentCartBig', data);
				this.context.forceUpdate('ComponentCartBig');
			} else if (this.context.get('ComponentCart')) {
				this.context.set('ComponentCart', data);
				this.context.forceUpdate('ComponentCart');
			}


			const state = this.state;
			state.contextData = data.componentData;

			notify.success(this.messages['SERVICE_ADD_TO_CART_SUCCESS']);
			if (this.mounted) {
				this.setState(state, () => {
					if (typeof callBackSuccess === 'function') {
						callBackSuccess(data);
					}
				});
			} else {
				if (typeof callBackSuccess === 'function') {
					callBackSuccess(data);
				}
			}
		};
		const actionData = {
			servicePriceId: servicePriceId,
			breadCrumbMode: breadCrumbMode,
			count: count,
		};
		ajaxParam.cypressParamString = '?ContextCart-ActionAddDServiceToCart';
		this.ajaxCall('ActionAddServiceToCart', actionData, ajaxParam);
	}

	render() {
		return (
		  <ContextCart.Provider value={this.state}>
			  {this.props.children}
		  </ContextCart.Provider>
		)
	}
}

/**
 *
 * @returns {ContextCartProvider}
 */
export const useCartContext = () => useContext(ContextCart);

export {ContextCart, ContextCartProvider};

